const titleMap = {
  "/": "Dashboard",
  "/settings": "Settings",
  "/home": "Dashboard",
  "/alerts": "Alerts",
  "/cameras": "Cameras",
  "/rules": "Rules",
  "/zones": "Zones",
  "/sites": "Sites",
  "/counts": "Counts",
  "/users": "Users",
  "/signin": "Sign In",
  "/select-site": "Select Site",
  "/signup": "Sign Up",
  "/rule/settings": "Rule | Settings",
  // "/aiassistant": "Solyntek Assistant"
  

};
/**
 * Returns the title of a page based on its route path.
 * @param {string} path - The path of the page route.
 * @returns {string} The title of the page with the site name appended.
 */
export const getTitleFromRoute = (path) => {
  if (titleMap[path]) {
    
    // window.onfocus = function () {
    //   return ` ${titleMap[path]} `;
    // }
    // window.onblur = function () {
    //   return ` Solyntek `;
    // }
    // window.addEventListener("blur", () => {
    //   return ` ${titleMap[path]} `;
    // })
    // window.addEventListener("focus", () => {
    //   return ` ${titleMap[path]} `;
    // })
    return `${titleMap[path]}`;
  }


  return "Solyntek";
};
